import { IKnmFormRiskIndicators } from 'KnmPackage/MainModule/interfaces/IKnmFormRiskIndicators';
import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';
import { IKnmReasonTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmReasonTypeSelectOption';

import { makeRequired } from '../../../CorePackage/MainModule/validators/isRequired';

export const getRiskIndicatorsValidate = (
  riskIndicators: IKnmFormRiskIndicators[] | undefined,
  type: IKnmReasonTypeSelectOption | undefined,
): FormErrors<IKnmFormRiskIndicators>[] | string | undefined => {
  if (!riskIndicators || !riskIndicators?.length) {
    return 'Поле не может быть пустым';
  }

  return riskIndicators?.map(item => ({
    riskIndicator: makeRequired('Поле не может быть пустым')(item.riskIndicator),
    indicatorRiskAttachment:
      type?.indicatorRiskRequiredFile && !item?.indicatorRiskAuto
        ? makeRequired('Поле не может быть пустым')(item?.indicatorRiskAttachment)
        : undefined,
    indicatorRiskAuto:
      type?.indicatorRiskRequiredAuto && !item?.indicatorRiskAttachment
        ? makeRequired('Поле не может быть пустым')(item?.indicatorRiskAuto)
        : undefined,
  }));
};
